<template>

  <aside class="mt-10 mb-3 border-b border-red-200">
    <h3 class="text-lg ">
      <span>{{ setMatText.header_configuration[lang] }}</span>
    </h3>
    <nav class="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-5 gap-6 items-end mb-5">

      <div>
        <label class="block text-sm font-medium "
               for="setCaseType"
        >{{ setMatText.input_label_set_asu_casing[lang] }}
        </label>
        <select v-model="setCaseType"
                class="input-md w-full"
        >
          <option v-for="caseItem in asuCasingTypeList"
                  :value="caseItem.short"
                  v-text="caseItem.value[lang]"
          ></option>
        </select>
      </div>

      <div>
        <label class="block text-sm font-medium "
               for="setAirSupply"
        >{{ setMatText.select_asu_dl[lang] }}
        </label>
        <select v-model="setAirSupply"
                class="input-md w-full"
        >
          <option v-for="asType in airSupplyTypeList"
                  :value="asType.short"
                  v-text="asType.value[lang]"
          ></option>
        </select>
      </div>

      <div>
        <label class="block text-sm font-medium "
               for="setPowerSupply"
        >{{ setMatText.input_label_set_power_supply[lang] }}
        </label>
        <select v-model="setPowerSupply"
                class="input-md w-full"
        >
          <option v-for="ppItem in powerSupplyList"
                  :value="ppItem.short"
                  v-text="ppItem.value[lang]"
          ></option>
        </select>
      </div>

      <div>
        <label class="block text-sm font-medium "
               for="setOutput"
        >{{ setMatText.input_label_set_output_signal[lang] }}
        </label>
        <select v-model="setOutput"
                class="input-md w-full"
        >
          <option v-for="opItem in outputTypeList"
                  :value="opItem.short"
                  v-text="opItem.value[lang]"
          ></option>
        </select>
      </div>


      <button class="button-set col-span-2 sm:col-span-1"
              type="button"
              @click="addSpec()"
      >
        <span class="inline mx-3">{{ setMatText.btn_label_add_specification[lang] }}</span>
        <svg xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 384 512"
             class="w-3 h-3 sm:w-4 sm:h-4 text-red-500"
        ><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
          <path d="M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z"
                style="fill:currentColor"
          />
        </svg>
      </button>

    </nav>

  </aside>

</template>
<script setup>

import {ref} from "vue";
import setMatText from "../../lang/setMaterials.json";
import {airSupplyTypeList, asuCasingTypeList, outputTypeList, powerSupplyList,} from "../configs/config-main";

const props = defineProps({
  lang: {
    type: String,
    default: 'de'
  },
  casetype: {
    type: String,
    default: 'asuclosed'
  }
})

const emits = defineEmits(['setnewpostext'])

const setNewPosText = ref('')
const setPowerSupply = ref('S230')
const setOutput = ref('a420')
const setCaseType = ref(props.casetype)
const setAirSupply = ref('mp')

const addSpec = () => {

  setNewPosText.value = setMatText.label_asu_main[props.lang] + ' ' +
      asuCasingTypeList[setCaseType.value].value[props.lang] + ' ' +
      setMatText.set_postext_with[props.lang] + ' ' +
      powerSupplyList[setPowerSupply.value].value[props.lang] + ' ' +
      setMatText.input_label_set_power_supply[props.lang] + ', ' +
      airSupplyTypeList[setAirSupply.value].value[props.lang] + ' ' +
      setMatText.set_postext_and[props.lang] + ' ' +
      outputTypeList[setOutput.value].value[props.lang] + ' ' +
      setMatText.input_label_set_output_signal[props.lang]

  emits('setnewpostext', setNewPosText.value)

}

</script>